export const proposalsview = [
  {
    id: "1",
    title: "We scheduled a meeting for next week",
    activityType: "Meeting",
    dueDate: "25 Sep 2023, 12:12 pm",
    owner: "Hendry",
    createdAt: "22 Sep 2023, 10:14 am",
    key: "1"
  },
  {
    id: "2",
    title: "Had conversation with Fred regarding task",
    activityType: "Calls",
    dueDate: "29 Sep 2023, 04:12 pm",
    owner: "Monty Beer",
    createdAt: "27 Sep 2023, 03:26 pm",
    key: "2"
  },
  {
    id: "3",
    title: "Analysing latest time estimation for new project",
    activityType: "Email",
    dueDate: "11 Oct 2023, 05:00 pm",
    owner: "Bradtke",
    createdAt: "03 Oct 2023, 03:53 pm",
    key: "3"
  },
  {
    id: "4",
    title: "Store and manage contact data",
    activityType: "Task",
    dueDate: "19 Oct 2023, 02:35 pm",
    owner: "Swaniawski",
    createdAt: "14 Oct 2023, 01:25 pm",
    key: "4"
  },
  {
    id: "5",
    title: "Will have a meeting before project start",
    activityType: "Meeting",
    dueDate: "27 Oct 2023, 12:30 pm",
    owner: "Sally",
    createdAt: "21 Oct 2023, 03:00 pm",
    key: "5"
  },
  {
    id: "6",
    title: "Call John and discuss about project",
    activityType: "Calls",
    dueDate: "12 Nov 2023, 10:20 pm",
    owner: "Itzel",
    createdAt: "02 Nov 2023, 05:35 pm",
    key: "6"
  },
  {
    id: "7",
    title: "Built landing pages",
    activityType: "Task",
    dueDate: "25 Nov 2023, 01:40 pm",
    owner: "Danny",
    createdAt: "20 Nov 2023, 08:20 am",
    key: "7"
  },
  {
    id: "8",
    title: "Regarding latest updates in project",
    activityType: "Email",
    dueDate: "30 Nov 2023, 09:20 pm",
    owner: "Lynch",
    createdAt: "25 Nov 2023, 07:20 pm",
    key: "8"
  },
  {
    id: "9",
    title: "Discussed budget proposal with Edwin",
    activityType: "Calls",
    dueDate: "08 Dec 2023, 04:35 pm",
    owner: "Merwin",
    createdAt: "01 Dec 2023, 10:45 am",
    key: "9"
  },
  {
    id: "10",
    title: "Attach final proposal for upcoming project",
    activityType: "Email",
    dueDate: "19 Dec 2023, 02:20 pm",
    owner: "Andrew",
    createdAt: "10 Dec 2023, 06:30 pm",
    key: "10"
  },
];
